import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";
import { sizing , spacing} from '@mui/system';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

const ProductCard = ({ product, handleAddToCart }) => {

 
  return (
    <Card className="card" >
        <CardMedia 
          component="img"
          height="270"
          image={product.image}
          alt={product.name}
          sx={{m:1}}
        />
        <CardContent >
          <Typography gutterBottom  component="div" sx={{m:1}}>
          {product.name}
          </Typography>
          <Typography color="text.primary" sx={{m:1}}>
           <strong> ${product.cost}</strong>
          </Typography>
          <Rating name="read-only" value={product.rating} readOnly sx={{m:1}}/>
          <Button variant = "contained" fullWidth  onClick={handleAddToCart} sx={{m:1}}>
            <AddShoppingCartIcon sx={{ fontSize: "20px", marginRight: '.5rem'}}/>ADD TO CART</Button>
        </CardContent>
  </Card>
  );
};

export default ProductCard;
